import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDLetterhead, FDStack, useFDBodyColor,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { ProgressBar } from 'Views/FreemiumEntry/HasRelationship/Content/Templates/PicklistQuestion/ProgressBar';
import StepNavigationFooter from 'Packages/FacetDesign/Components/Experimental/StepNavigationFooter';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import {
  useBuildCommonFQEventProperties,
} from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import useMobileLayout from 'Hooks/useMobileLayout';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';

const InsightIntro = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();
  const isMobile = useMobileLayout();

  useScrollTopOnMount();

  useFDBodyColor('emphasized');

  const imageRel = resource.withRelationship(fr.relationships.cardHeaderImage.name, (rel) => rel, () => undefined);
  return (
    <QuizWrapperLayout>
      <FDStack direction={'column'} spacing={4} {...dataAttrs('insight-container')}>
        <ProgressBar />
        <FDStack direction={'column'} spacing={4}>
          <FDStack direction={'column'} spacing={2} paddingY={isMobile ? 4 : 8}>
            <MetaControlField attr={'title'} />
            <MetaControlField attr={'insightDescription'} />

            {resource.attr('cardDescription') ? (
              <FDLetterhead title={resource.attr('cardTitle')} image={imageRel?.link('related').url()} avatarSize={imageRel?.meta('avatarSize') || 'md'}>
                <MetaControlField attr={'cardDescription'} />
              </FDLetterhead>) : null}

            <LottieLoadingLayout>
              <FDStack direction={'column'} paddingY={isMobile ? 4 : 8}>
                <LottieRel relationship={resource.relationship(fr.relationships.lottie.name)} />
              </FDStack>
            </LottieLoadingLayout>

          </FDStack>
          {resource.meta().canPut() && <StepNavigationFooter
            onNext={() => {
              logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
                eventProperties: {
                  ...buildCommonFQEventProperties(resource),
                  insightId: resource.attr('insightId'),
                  insightReferenceName: resource.attr('insightReferenceName'),
                },
              });
              onSubmit();
            }}
            isLoading={saving}
            label={resource.attr('primaryActionLabel') || 'Continue'}
          />}
        </FDStack>
      </FDStack>
    </QuizWrapperLayout>
  );
};

export { InsightIntro };
